import { FieldError } from '@azelis/ui/components/field';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@azelis/ui/components/table';

import { useSubmitWizard } from './submit-wizard-context';

export function FinishStep() {
  const {
    productName,
    country,
    questionnaireFile,
    selectedDocumentIds,
    extraDocuments,
    submitError,
  } = useSubmitWizard();

  return (
    <div className="w-full py-8">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="text-base font-bold text-foreground">
              Review and Submit
            </TableHead>
            <TableHead className="text-right text-base font-bold text-foreground">
              {productName}
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow>
            <TableCell className="text-muted-foreground">Product</TableCell>
            <TableCell className="text-right font-medium">{productName}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="text-muted-foreground">Country</TableCell>
            <TableCell className="text-right font-medium">{country}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="text-muted-foreground">Questionnaire file</TableCell>
            <TableCell className="text-right font-medium">
              {questionnaireFile?.name ?? '—'}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="text-muted-foreground">Selected documents</TableCell>
            <TableCell className="text-right font-medium">
              {selectedDocumentIds.length}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="text-muted-foreground">Extra documents</TableCell>
            <TableCell className="text-right font-medium">{extraDocuments.length}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
      {submitError ? <FieldError className="mt-4">{submitError}</FieldError> : null}
    </div>
  );
}
